export default __webpack_public_path__ + "static/media/dndhomepage.7052b963.png";